import React, { Dispatch, useState } from 'react';
import { Button, Form, Input, Select } from 'antd';

import { PackagesAction } from 'leash/reducers/packages/PackagesReducer';
import {
  getPackageFacets,
  mapTravelPackages,
} from 'leash/utilities/packages/packages.utilities';
import { testId } from 'leash/utilities/test/dataTestId';
import { SearchTravelPlaningEntity } from 'leash/types';
import { apiContent } from 'utilities/http/api/leash/apiContent';
import { ArchivedSearchFormStyled } from './ArchivedSearchForm.styles';

interface Props {
  dispatch: Dispatch<PackagesAction>;
  setShowResults: Dispatch<boolean>;
}

function ArchivedSearchForm(props: Props) {
  const { dispatch, setShowResults } = props;
  const [disabled, setDisabled] = useState(true);
  const [form] = Form.useForm();

  const handleSearch = async (values: {
    searchBy: SearchTravelPlaningEntity;
    searchValue: number;
  }) => {
    setShowResults(true);
    dispatch({ type: 'LOAD_PACKAGES' });
    const resp = await apiContent.searchTravelPlanning({
      entity: values.searchBy,
      entityId: values.searchValue,
    });
    dispatch({
      type: 'SET_PACKAGES',
      payload: {
        facets: getPackageFacets(resp?.json.travelPlans),
        packages: mapTravelPackages(resp?.json.travelPlans),
      },
    });
  };

  const handleValuesChange = () => {
    const { searchBy, searchValue } = form.getFieldsValue();
    setDisabled(!searchBy || !searchValue);
  };

  return (
    <ArchivedSearchFormStyled
      data-testid={testId.archivedSearchForm}
      layout="inline"
      onFinish={handleSearch}
      onFieldsChange={handleValuesChange}
      form={form}
      initialValues={{ searchBy: 'puppy' }}
    >
      <Form.Item name="searchBy" style={{ minWidth: '8rem' }}>
        <Select
          placeholder="Search by"
          data-testid={testId.archivedSearchFormFieldSearchBy}
        >
          <Select.Option
            data-testid={testId.archivedSearchFormFieldSearchByPuppyId}
            value="puppy"
          >
            Puppy ID
          </Select.Option>
          <Select.Option value="customer">Customer ID</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item name="searchValue" style={{ minWidth: '16.5rem' }}>
        <Input.Search
          data-testid={testId.archivedSearchFormFieldSearchValue}
          placeholder="Type the id number here"
          autoComplete="off"
          type="number"
          allowClear
          enterButton={
            <Button
              data-testid={testId.archivedSearchFormButtonSearch}
              type="primary"
              htmlType="submit"
              disabled={disabled}
            >
              Search
            </Button>
          }
        />
      </Form.Item>
    </ArchivedSearchFormStyled>
  );
}

export default ArchivedSearchForm;
